"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var LangUtils_1 = require("@twii/core/lib/LangUtils");
var Error_classNames_1 = require("./Error.classNames");
var Error_styles_1 = require("./Error.styles");
var Tooltip_1 = require("office-ui-fabric-react/lib/Tooltip");
var Icon_1 = require("office-ui-fabric-react/lib/Icon");
var ErrorItem = /** @class */ (function (_super) {
    __extends(ErrorItem, _super);
    function ErrorItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErrorItem.prototype.render = function () {
        var styles = Error_styles_1.getStyles(undefined, this.props.styles);
        var classNames = Error_classNames_1.getClassNames(styles, this.props.className);
        return (React.createElement("div", { className: classNames.item },
            React.createElement("div", { className: classNames.itemTitle }, this.props.title),
            React.createElement("div", { className: classNames.itemValue }, this.props.children)));
    };
    return ErrorItem;
}(React.Component));
var ErrorMessage = /** @class */ (function (_super) {
    __extends(ErrorMessage, _super);
    function ErrorMessage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErrorMessage.prototype.render = function () {
        var error = this.props.error;
        if (error) {
            var styles = Error_styles_1.getStyles(undefined, this.props.styles);
            var classNames = Error_classNames_1.getClassNames(styles, this.props.className);
            var message = LangUtils_1.isString(error) ? error : error && error.message ? error.message : "An error has occurred";
            return React.createElement("div", { className: classNames.message, key: "message" }, message);
        }
        return null;
    };
    return ErrorMessage;
}(React.Component));
var ErrorStack = /** @class */ (function (_super) {
    __extends(ErrorStack, _super);
    function ErrorStack() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErrorStack.prototype.render = function () {
        var error = this.props.error;
        if (error) {
            var stack = error ? error.stack : null;
            if (stack) {
                return React.createElement(ErrorItem, { className: "stack-item", title: "Stack" },
                    React.createElement("pre", null, stack));
            }
        }
        return null;
    };
    return ErrorStack;
}(React.Component));
var ErrorDetail = /** @class */ (function (_super) {
    __extends(ErrorDetail, _super);
    function ErrorDetail() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErrorDetail.prototype.render = function () {
        var error = this.props.error;
        if (error) {
            var r_1 = [];
            if (LangUtils_1.isObject(error)) {
                Object.keys(error).forEach(function (key) {
                    if (key !== "message" && key !== "stack") {
                        var value = error[key];
                        if (value) {
                            var valueContent = void 0;
                            if (LangUtils_1.isObject(value)) {
                                try {
                                    valueContent = React.createElement("pre", null, JSON.stringify(value, null, "\t"));
                                }
                                catch (err) { }
                            }
                            else {
                                valueContent = String(value);
                            }
                            if (valueContent) {
                                r_1.push(React.createElement(ErrorItem, { key: key, title: key },
                                    React.createElement("pre", null, valueContent)));
                            }
                        }
                    }
                });
            }
            return r_1;
        }
        return null;
    };
    return ErrorDetail;
}(React.Component));
var Error = /** @class */ (function (_super) {
    __extends(Error, _super);
    function Error() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Error.prototype.render = function () {
        if (this.props.error) {
            var styles = Error_styles_1.getStyles(undefined, this.props.styles);
            var classNames = Error_classNames_1.getClassNames(styles, this.props.className);
            return (React.createElement("div", { className: classNames.root, role: "error" },
                React.createElement(ErrorMessage, __assign({}, this.props)),
                React.createElement(ErrorStack, __assign({}, this.props)),
                React.createElement(ErrorDetail, __assign({}, this.props))));
        }
        return null;
    };
    return Error;
}(React.Component));
exports.Error = Error;
var CompactError = /** @class */ (function (_super) {
    __extends(CompactError, _super);
    function CompactError() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onRenderTooltipContent = function () {
            return React.createElement(Error, { error: _this.props.error });
        };
        return _this;
    }
    CompactError.prototype.render = function () {
        if (this.props.error) {
            var styles = Error_styles_1.getStyles(undefined, this.props.styles);
            var classNames = Error_classNames_1.getClassNames(styles, this.props.className);
            return (React.createElement("div", { className: classNames.compact },
                React.createElement(Tooltip_1.TooltipHost, { tooltipProps: { onRenderContent: this._onRenderTooltipContent } },
                    React.createElement(Icon_1.Icon, { iconName: "Error" }))));
        }
        return null;
    };
    return CompactError;
}(React.Component));
exports.CompactError = CompactError;
